import React from 'react'
import {INavNotification} from '@api/user/account/notification/getNotification'
import {useTranslation} from '@lib/intl/useTranslations'
import useNavigation from '@hook/useNavigation'
import NotificationItemLayout from '@feature/account/components/notifications/NotificationListItem/layout/NotificationItemLayout'
import ic_default_user from '@image/ic_default_user.webp'
import ic_default_user_dark from '@image/ic_default_user_dark.webp'
import useDark from '@hook/useDark'

interface INotificationItem extends INavNotification {}

const FollowNotificationItem = (props: INotificationItem) => {
    const t = useTranslation()
    const {data} = props
    const {goSubscriber} = useNavigation()
    const {isRenderDark} = useDark()

    return (
        <NotificationItemLayout
            {...props}
            thumbnail={
                props?.thumbnail ? props?.thumbnail : isRenderDark ? ic_default_user_dark.src : ic_default_user.src
            }
            text={t(`globalNotification.NotificationItem.follow`, {
                follower_name: data?.follower_name ?? '',
            })}
            onClick={() => goSubscriber('followers')}
        />
    )
}

export default FollowNotificationItem
